import React, { useState } from "react";
import Header from "../../component/Header";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./style.css";
import api from "../../Services/api";
import { useSwal } from "../../component/sweetalert";
export default function AddEvents() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [description, setDescription] = useState("");
  const [selectedMode, setSelectedMode] = useState("");
  const [venue, setVenue] = useState("");
  const [refreshmentsTimeStart, setRefreshmentsTimeStart] = useState("");
  const [refreshmentsTimeEnd, setRefreshmentsTimeEnd] = useState("");
const [loading, setLoading] = useState(false);

  const handleRadioChange = (event) => {
    setSelectedMode(event.target.value);
  };

  const alert = useSwal();
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/webp"];
      if (!validTypes.includes(file.type)) {
        alert("error", "Only JPG, PNG, and WEBP files are allowed.");
        return;
      }
      setSelectedFile(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

  const startTime = e.target.startTime.value;
  const endTime = e.target.endTime.value;

  const parseTime = (t) => parseInt(t.replace(":", ""), 10);

  if (parseTime(endTime) <= parseTime(startTime)) {
    alert("error", "End Time should be greater than Start Time.");
      setLoading(false);
    return;
  }

    if (selectedMode === "Offline Meeting") {
    if (refreshmentsTimeStart && refreshmentsTimeEnd) {
      const start = new Date(`2000-01-01T${refreshmentsTimeStart}`);
      const end = new Date(`2000-01-01T${refreshmentsTimeEnd}`);

      if (end <= start) {
        alert("error", "Refreshments End Time must be after Start Time.");
          setLoading(false);
        return;
      }
    }
  }
    const formData = new FormData();
    formData.append("title", e.target.title.value);
    formData.append("link", e.target.meetingLink.value);
    formData.append("event_date", e.target.date.value);
    formData.append("starttime", e.target.startTime.value);
    formData.append("endtime", e.target.endTime.value);
    formData.append("ModeOfMeeting", e.target.confirm.value);
    formData.append("contents", description);
    if (selectedFile) {
      formData.append("image", selectedFile);
    }
    if (selectedMode === "Offline Meeting") {
      formData.append("venue", venue);
      formData.append("refreshments_time_start", refreshmentsTimeStart);
      formData.append("refreshments_time_end", refreshmentsTimeEnd);
    }

    try {
      setLoading(true);
      const response = await api.post("/insertEvent", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 201) {
        alert("success", "Event added successfully!");
        e.target.reset();
        setSelectedFile(null);
        setDescription("");
        setVenue("");
        setRefreshmentsTimeStart("");
        setRefreshmentsTimeEnd("");
      } else {
        await alert("error", response.data.message || "Failed to add event.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      await alert("error", "Failed to submit event. Please try again.");
  } finally {
    setLoading(false); // stop loading
  }
};

  return (
    <section className="dashboardpage">
      <Header pageTitle="Add Events Details" backTo="/events" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-start col-xl-6 col-12">
          <form className="form-fields d-flex" onSubmit={handleSubmit}>
            <div className="grid-container">


              <div className="input-container">
                <input
                  type="text"
                  id="title"
                  name="title"
                  required
                  placeholder="Enter Event Title"
                />
                <span className="underline"></span>
              </div>


              <div className="radio-container">
                <span className="radio-label">Select Mode of Meeting</span>
                <div className="radio-container button">
                  <label
                    className={`radio-option ${
                      selectedMode === "Online Meeting" ? "active" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="confirm"
                      onChange={handleRadioChange}
                      checked={selectedMode === "Online Meeting"}
                      value="Online Meeting"
                      required
                    />{" "}
                    Online Meeting
                  </label>
                  <label
                    className={`radio-option ${
                      selectedMode === "Offline Meeting" ? "active" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      onChange={handleRadioChange}
                      checked={selectedMode === "Offline Meeting"}
                      name="confirm"
                      value="Offline Meeting"
                      required
                    />{" "}
                    Offline Meeting
                  </label>
                </div>
              </div>

              <div className="input-container">
                <input type="date" id="date" name="date" required />
                <label htmlFor="date">Enter Event Date</label>
                <span className="underline"></span>
              </div>

           <div className="input-container">
  <input
    type="text"
    id="meetingLink"
    name="meetingLink"
    placeholder="Enter Meeting Link"
    required={selectedMode === "Online Meeting"} // Only required for Online
  />
  <span className="underline"></span>
</div>


              {selectedMode === "Offline Meeting" && (
                <>
                  <div className="input-container">
                    <input
                      type="text"
                      name="venue"
                      placeholder="Enter Venue"
                      value={venue}
                      onChange={(e) => setVenue(e.target.value)}
                      required
                    />
                    <span className="underline"></span>
                  </div>
                  <div className="refreshmentsTimeStart">
                    <div className="input-container">
                      <input
                        type="time"
                        id="refreshmentsTimeStart"
                        name="refreshmentsTimeStart"
                        value={refreshmentsTimeStart}
                        onChange={(e) =>
                          setRefreshmentsTimeStart(e.target.value)
                        }
                      />
                      <label htmlFor="refreshmentsTimeStart">
                        Refreshments Start Time
                      </label>
                      <span className="underline"></span>
                    </div>

                    <div className="input-container">
                      <input
                        type="time"
                        id="refreshmentsTimeEnd"
                        name="refreshmentsTimeEnd"
                        value={refreshmentsTimeEnd}
                        onChange={(e) => setRefreshmentsTimeEnd(e.target.value)}
                      />
                      <label htmlFor="refreshmentsTimeEnd">
                        Refreshments End Time
                      </label>
                      <span className="underline"></span>
                    </div>
                  </div>
                </>
              )}

              <div className="input-container file-input-container">
                {selectedFile && (
                  <p className="file-name">{selectedFile.name}</p>
                )}
                <input
                  type="file"
                  id="fileUpload"
                  name="fileUpload"
                  onChange={handleFileChange}
                  accept=".jpg, .jpeg, .png, .webp"
                />
                <span className="underline"></span>
              </div>
              <div className="Eventstarttime">
                <div className="input-container">
                  <input type="time" id="startTime" name="startTime" required />
                  <label htmlFor="startTime">Enter Event Start Time</label>
                  <span className="underline"></span>
                </div>

                <div className="input-container">
                  <input type="time" id="endTime" name="endTime" required />
                  <label htmlFor="endTime">Enter Event End Time</label>
                  <span className="underline"></span>
                </div>
              </div>

              <div className="input-container description-container">
                <ReactQuill
                  value={description}
                  onChange={setDescription}
                  theme="snow"
                  placeholder="Description"
                  className="react-quill-wrapper"
                />
              </div>

            <button className="btn btn-purpal" type="submit" disabled={loading}>
  {loading ? "Submitting..." : "Submit"}
</button>

            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
